"use strict";
/* eslint-disable no-param-reassign */
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayMemberNumberToString = exports.unflattenObject = void 0;
/**
 * Utils module.
 * @module misc
 * @see https://gitlab.cdfsunrise.com/frontend/core/-/tree/main/packages/utils
 */
/**
 * @param data T
 * @returns T
 * @example
 * ``` js
 * { 'a.b.c': 1, d: 1 } => { a: { b: { c: 1 } }, d: 1 }
 * ```
 */
var unflattenObject = function (data) {
    var result = {};
    var _loop_1 = function (i) {
        var keys = i.split('.');
        keys.reduce(function (acc, value, index) {
            // eslint-disable-next-line no-restricted-globals
            return acc[value] || (acc[value] = isNaN(Number(keys[index + 1])) ? (keys.length - 1 === index ? data[i] : {}) : []);
        }, result);
    };
    for (var i in data) {
        _loop_1(i);
    }
    return result;
};
exports.unflattenObject = unflattenObject;
/**
 * 将数组整型转成字符串整型
 *  * @example
 * ``` js
 * [1,2,3,undefined,null]=>['1','2','3','','']
 * ```
 *
 * @param arr (string | number | undefined | null)[]
 * @returns string[]
 */
var arrayMemberNumberToString = function (arr) {
    var tar = JSON.parse(JSON.stringify(arr));
    tar = tar.reduce(function (sum, item) {
        if (typeof item === 'number') {
            item = String(item).trim();
        }
        else if (item === undefined || item === null) {
            item = '';
        }
        sum.push(item);
        return sum;
    }, []);
    return tar;
};
exports.arrayMemberNumberToString = arrayMemberNumberToString;
//# sourceMappingURL=index.js.map